import { stats } from '@/mocks/articles';

export default function AboutStats() {
  const statItems = [
    { label: '累计爆料', value: `${(stats.totalArticles / 100).toFixed(0)}+`, suffix: '篇', desc: '覆盖6大内容分类' },
    { label: '全网曝光', value: `${(stats.monthlyExposures / 1000000).toFixed(1)}M`, suffix: '', desc: '月度内容触达' },
    { label: '日活用户', value: `${(stats.dailyActive / 10000).toFixed(1)}万`, suffix: '', desc: '活跃吃瓜群众' },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-4">
          <span className="font-heading text-xs tracking-widest uppercase text-foreground-500 font-semibold">
            声誉 · 数据
          </span>
        </div>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-12">
          数据与声誉
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="rounded-2xl bg-primary-500 p-8 flex flex-col justify-between min-h-[280px]">
            <div className="absolute">
              <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-background-50/20 text-background-50 text-xs font-bold">
                数
              </span>
            </div>
            <div className="mt-auto pt-12">
              <div className="text-5xl md:text-6xl font-bold text-background-50">
                {statItems[0].value}
                <span className="text-2xl">{statItems[0].suffix}</span>
              </div>
              <p className="mt-2 text-background-50/80 text-sm">{statItems[0].label}</p>
              <p className="text-background-50/50 text-xs mt-1">{statItems[0].desc}</p>
            </div>
          </div>

          <div className="rounded-2xl overflow-hidden relative min-h-[280px]">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20concept%20with%20warm%20cream%20and%20coral%20tones%2C%20minimalist%20editorial%20style%2C%20rising%20graph%2C%20modern%20design&width=600&height=450&seq=about-stats-mid&orientation=portrait"
              alt="数据展示"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
            <div className="absolute top-6 left-6">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium">
                <i className="ri-bar-chart-line w-3 h-3 flex items-center justify-center" />
                数据增长
              </span>
            </div>
            <div className="absolute bottom-6 left-6">
              <div className="text-4xl font-bold text-background-50">{statItems[1].value}</div>
              <p className="text-background-50/70 text-sm mt-1">{statItems[1].desc}</p>
            </div>
          </div>

          <div className="rounded-2xl bg-background-50 overflow-hidden flex flex-col min-h-[280px]">
            <div className="p-8 flex flex-col flex-1">
              <h3 className="font-heading text-3xl font-bold text-foreground-950">
                行业认可
              </h3>
              <p className="mt-3 text-foreground-500 text-sm leading-relaxed">
                多次获得新媒体行业奖项，被多家主流媒体引用报道。2025年获评"年度最具影响力新媒体"。
              </p>
              <div className="mt-auto pt-6">
                <div className="text-4xl font-bold text-accent-500">{statItems[2].value}</div>
                <p className="text-foreground-400 text-xs mt-1">{statItems[2].desc}</p>
              </div>
            </div>
            <div className="h-32 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Award%20ceremony%20concept%20with%20warm%20golden%20and%20cream%20tones%2C%20editorial%20style%2C%20minimalist%2C%20achievement%20theme&width=600&height=200&seq=about-awards&orientation=landscape"
                alt="奖项荣誉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}